import { gql } from '@apollo/client';
import ErrorResultFragment from "../../fragments/ErrorResult";

const UPDATE_OVERVIEW_DASHBOARD = gql`
  mutation UpdateOverviewDashboard(
    $companyId: Int!
    $id: Int
    $filter: DashboardType!
    $route: String
    $jsonContent: String
    $dashboardSettings: DashboardSettingsInput!
  ) {
    dashboardContext {
      updateOverviewDashboard(
        companyId: $companyId
        id: $id
        filter: $filter
        route:$route
        jsonContent: $jsonContent
        dashboardSettings: $dashboardSettings
      ) {
        errorResult {
          ...ErrorResultFields
        }
        success
      }
    }
  }
  ${ErrorResultFragment}
`;

export default UPDATE_OVERVIEW_DASHBOARD;
